import React from "react";

const EditProfile = () => {
  return <div>edit profile!</div>;
};

export default EditProfile;
